import { render, staticRenderFns } from "./ContratoTagsNovo.vue?vue&type=template&id=7d34d5e4"
import script from "./ContratoTagsNovo.vue?vue&type=script&lang=js"
export * from "./ContratoTagsNovo.vue?vue&type=script&lang=js"
import style0 from "./ContratoTagsNovo.vue?vue&type=style&index=0&id=7d34d5e4&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports